import React from "react";

import SessionExpired from "../pages/SessionExpired";

export default () => {
  return <SessionExpired />;
};
